import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

export function useGetEtapas() {
  const fetchData = async () => {
    const LISTAR_ETAPAS = `${leadsWebEnviroment}/mobile/etapas-funil/v1`;
    const response = await instance.get(LISTAR_ETAPAS);
    return response?.data?.data;
  };

  const query = useQuery({
    enabled: false,
    queryFn: fetchData,
    queryKey: ["listar_etapas"],
    refetchOnWindowFocus: false,
  });

  return query;
}
